import { MDBIcon } from "mdb-react-ui-kit";
import { useContext } from "react";
import useResumeBusinessSkillsHandlers from "../../../../context/resume/hooks/resume-business-skills-handlers";
import { TranslationContext } from "../../../../context/translations/translations-context";
import useResumeProperties from "../../../../hooks/useResumeProperties";
import AddCompetence from "../competences/AddCompetence";
import CompetenceList from "../competences/CompetenceList";

export default function CategoryItem(
    {
        item,
        numberOfItems,
        refCompetences,
        refCompetencesCategories,
    } ) {

    const { translations } = useContext(TranslationContext);
    const { documentLanguage } = useResumeProperties();
    const { handleMoveCategoryUp, handleMoveCategoryDown, handleRemoveCategory } = useResumeBusinessSkillsHandlers();

    const normalizeLabel = ( value ) => {
        if ( !value ) {
            return '';
        }
        return value
            .toString()
            .normalize( 'NFD' )
            .replace( /[\u0300-\u036f]/g, '' )
            .trim()
            .toLowerCase();
    };

    const resolveCategoryId = () => {
        if ( item.category?.id ) {
            return item.category.id;
        }
        if ( !item.category?.translations || !Array.isArray( refCompetencesCategories ) ) {
            return undefined;
        }
        const candidates = [];
        const translations = item.category.translations;
        if ( documentLanguage && translations[ documentLanguage ] ) {
            candidates.push( translations[ documentLanguage ] );
        }
        if ( translations.fr ) {
            candidates.push( translations.fr );
        }
        if ( translations.en ) {
            candidates.push( translations.en );
        }
        for ( const label of candidates ) {
            const normalized = normalizeLabel( label );
            if ( !normalized ) {
                continue;
            }
            const matched = refCompetencesCategories.find( category => {
                const refTranslations = category.translations || {};
                return normalizeLabel( refTranslations.fr ) === normalized
                    || normalizeLabel( refTranslations.en ) === normalized
                    || ( documentLanguage
                        && normalizeLabel( refTranslations[ documentLanguage ] ) === normalized );
            } );
            if ( matched?.id ) {
                return matched.id;
            }
        }
        return undefined;
    };

    const resolvedCategoryId = resolveCategoryId();
    const normalizedCategoryId = Number.isInteger( resolvedCategoryId )
        ? resolvedCategoryId
        : Number.parseInt( resolvedCategoryId, 10 );

    return (
        <div className="mt-2">
            <div className="d-flex align-items-center gap-2">
                <p className="h6 pt-2">
                    { item.category?.translations?.[ documentLanguage ] }
                </p>
                <div className="d-flex align-items-center gap-2 justify-content-end">
                    <MDBIcon
                        fas
                        icon="arrow-up"
                        role="button"
                        size="1x"
                        onClick={ () => item.order !== 0 && handleMoveCategoryUp( item ) }
                        style={ { cursor: item.order !== 0 ? "pointer" : "default" } }
                        color={ item.order !== 0 ? "" : "muted" }
                    />
                    <MDBIcon
                        fas
                        icon="arrow-down"
                        role="button"
                        onClick={ () => item.order !== numberOfItems - 1 && handleMoveCategoryDown( item ) }
                        style={ { cursor: item.order !== numberOfItems - 1 ? "pointer" : "default" } }
                        color={ item.order !== numberOfItems - 1 ? "" : "muted" }
                    />
                    <MDBIcon
                        fas
                        icon="trash-alt"
                        role="button"
                        onClick={ () => window.confirm(translations.general.confirmationMessage) && handleRemoveCategory( item ) }
                        style={ { cursor: 'pointer' } }
                        color='light'
                    />
                    <AddCompetence parentOrder={ item.order }/>
                </div>
            </div>
            <CompetenceList
                items={ item.competences }
                categoryId={ Number.isNaN( normalizedCategoryId ) ? undefined : normalizedCategoryId }
                parentOrder={ item.order }
                refCompetences={ refCompetences }
            />

        </div>
    );
};
